import { render } from "./SerialConfirm.vue?vue&type=template&id=3dd942f6"
import script from "./SerialConfirm.vue?vue&type=script&lang=js"
export * from "./SerialConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script